import { render, staticRenderFns } from "./permissionObj.vue?vue&type=template&id=12708cf0"
import script from "./permissionObj.vue?vue&type=script&lang=js"
export * from "./permissionObj.vue?vue&type=script&lang=js"
import style0 from "./permissionObj.vue?vue&type=style&index=0&id=12708cf0&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12708cf0')) {
      api.createRecord('12708cf0', component.options)
    } else {
      api.reload('12708cf0', component.options)
    }
    module.hot.accept("./permissionObj.vue?vue&type=template&id=12708cf0", function () {
      api.rerender('12708cf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/data_auth/permission_obj/permissionObj.vue"
export default component.exports